<mat-form-field>
  <mat-label>{{ control.label }}</mat-label>
  <input
    matInput
    [formControl]="inputControl"
    [readonly]="isReadonly"
    [required]="isRequired"
    [errorStateMatcher]="errorStateMatcher"
  />
</mat-form-field>
